module.exports = {"id":"185373","name":"Ivelin Popov","rating":"76","photo":"./data/images/photos/3/185373.png","club":{"name":"Rubin Kazan","logo":"./data/images/clubs/RubinKazan.png"},"positions":["MOC","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IvelinPopov0.json
// module id = 1854
// module chunks = 0